// toGetCurrentEvent.js

// import {getEventDetail} from "@/apis/eventDetail"

export default {
  state: {
    currentEvent: {
      setting_json: {},
    },
  },
  mutations: {
    AddCurrentEvent(state, payload) {
      state.currentEvent = payload;
    },
    AddSettingJson(state, payload) {
      state.currentEvent.setting_json = payload;
    },
  },
  actions: {},
};
